// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"f53d00cc","41":"e411e21b","121":"3832e487","146":"308dd099","170":"5e94c77f","292":"185eca4d","547":"2d8994b7","929":"ef76ec8f"}[chunkId] + ".chunk.js";
};